exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdl-card[_v-4814c693]{min-height:0}.profile-label[_v-4814c693]{padding:4px 0}.profile-textfield[_v-4814c693]{margin-top:-20px}.inner-grid[_v-4814c693]{margin:-8px;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4814c693&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/admin/forms/ServiceForm.vue
// module id = 267
// module chunks = 0